import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import { isAxiosError } from 'axios'
import { useSnackbar } from 'notistack'
import { TwoFATypes } from 'pages/MyAccountEdit/types'
import { postRequest } from 'utils/api/apiRequest'
import { useErrorSnackbar } from 'utils/hooks/useErrorSnackbar'

type Data = {
  code: string
  code_challenge: string
  twoFARememberToken?: string | null
  type: TwoFATypes | null
}

export const usePostVerifyTwoFA = (onSuccess: (tokens: { accessToken: string; refreshToken: string }) => void) => {
  const { enqueueSnackbar } = useSnackbar()
  const errorSnackbar = useErrorSnackbar()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: ({ twoFARememberToken, ...payload }: Data) =>
      postRequest(
        `/2fa/verify`,
        payload,
        twoFARememberToken ? { headers: { '2fa-verifier': twoFARememberToken } } : undefined
      ),
    onSuccess: (data) => {
      onSuccess({
        accessToken: data.data.access_token,
        refreshToken: data.data.refresh_token,
      })
      enqueueSnackbar(t('auth.login.success'), { variant: 'success' })
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        errorSnackbar(error, { DEFAULT_ERROR: t('app.not_authorized') })
      } else {
        enqueueSnackbar('app.not_authorized', { variant: 'error' })
      }
    },
  })
}
